'use client';

import {type FC} from 'react';

import SanityProjectDetailsProvider from './sanity-project-details-provider';

interface Props {
	children: React.ReactNode;
}

const projectDetails = {
	dataset: process.env.NEXT_PUBLIC_SANITY_DATASET ?? '',
	projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID ?? '',
};

export const AppProvider: FC<Props> = ({children}) => {
	return (
		<SanityProjectDetailsProvider projectDetails={projectDetails}>
			{children}
		</SanityProjectDetailsProvider>
	);
};
